// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__abUVB","description":"PatientConsentPreview_description__2HuPU"};